<div class="loading">
	<div class="lds-ellipsis">
		<div class="{{mode}}"></div>
		<div class="{{mode}}"></div>
		<div class="{{mode}}"></div>
		<div class="{{mode}}"></div>
	</div>
</div>
